import {addEvent} from '../add-event'

export function clickGetMoreOutOfMedullaEvent(): boolean {
    return addEvent('loginPageClickGetMoreOutOfMedulla', {})
}
